import { apiCall } from "../../services/dataUtils";


export const setAuthToken = (token) => {
  if (token) {
    apiCall.defaults.headers.common["Authorization"] = `${token}`;
  } else {
    delete apiCall.defaults.headers.common["Authorization"];
  }
};
